// postalcodes2/grid/filters.tsx
import React from 'react';
import { Row } from 'react-bootstrap';
import { FormCol, FormFilterCard, FieldInput } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectRegion } from 'shared-pages';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  const where: any = {};
  const or: any[] = [];

  if (values?.searchText?.trim()) {
    const like = { $like: `%${values.searchText.trim()}%` };
    or.push(
      { postalcode: like },
      { area: like },
      { city: like },
      { county: like },
      { country: like },
    );
  }

  if (values?.regionId) {
    where.regionId = Number(values.regionId); // dropdown → exact match
  }

  if (or.length) where.$or = or;

  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false }) => {
  const { t } = useTranslation();

  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    regionId: initialValues?.regionId ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση( Τ.Κ., Περιοχή, Πόλη, Νομός, Χώρα )')}
          type="search"
          disable={disable}
          tooltip={'Τ.Κ., Περιοχή, Πόλη, Νομός, Χώρα'}
        />
        <FieldSelectRegion
          as={FormCol}
          name="regionId"
          label={t('Περιφέρεια')}
          // defaultValues not needed in filters
          disabled={disable}
        />
      </Row>
    </FormFilterCard>
  );
};
